<template>
  <div
    :class="[
      'jlxk-img-detection-detail',
      { 'jlxk-audio-or-video-alter-detail': isCanAlter }
    ]"
  >
    <div class="left">
      <ImgCarousel
        :img-list="imgArrAttachments"
        :initial-index="Number(imgIndex)"
        @updateIndex="updateIndex"
      />
    </div>
    <el-tabs v-model="currentTab">
      <el-tab-pane
        v-for="item in tabList"
        :key="item.name"
        :label="item.name"
        :name="item.label"
      >
        <keep-alive>
          <components
            v-show="currentTab === item.label"
            :is="item.label"
            :ref="item.label"
            :detail="detailInfo"
            @updateDetail="getImageAiUpdate"
            @checkReback="checkReback"
          />
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
    <checkDialog
      ref="checkDialog"
      type="img"
      :checked-list="checkedListData"
      @handleVideoCheck="getImageAiCheck"
    />
  </div>
</template>

<script>
import tag from './components/imgTag'
import detection from './components/detection'
import characterRecognition from './components/characterRecognition'
import checkDialog from '@views/jlxk/review/components/checkDialog'
import ImgCarousel from '@components/jlxk/imgCarousel'
import APIS from '@apis/jlxk'
export default {
  name: 'Detail',
  props: {},
  components: {
    tag,
    detection,
    characterRecognition,
    checkDialog,
    ImgCarousel
  },
  data() {
    return {
      currentTab: 'tag',
      tabList: [
        {
          name: '图片标签',
          label: 'tag'
        },
        {
          name: '图像审核',
          label: 'detection'
        },
        {
          name: '人物识别',
          label: 'characterRecognition'
        }
      ],
      detailInfo: {
        type: 'img',
        tag: [],
        checkStatus: 0,
        checkResult: [],
        character: {}
      },
      checkedListData: [],
      imgArrAttachments: [],
      imgIndex: this.$route.query.index || 0
    }
  },
  computed: {
    currentIndex() {
      return this.$store.state.currentIndex
    },
    isCanAlter() {
      return this.$route.query.isAlter === 'true'
    },
    // 当前图片id
    currentId() {
      return (this.imgArrAttachments.length !== 0 && this.imgArrAttachments[this.imgIndex].id) || ''
    }
  },
  created() {
    this.$store.commit('UPDATE_BreadMenuData', [''])
    this.getFindImgList()
  },
  methods: {
    // 图片列表获取
    async getFindImgList() {
      let { status, data } = await APIS.postFindImgList({
        data: { docId: this.$route.query.docId, articleTypeId: this.$route.query.articleTypeId }
      })
      if (status === 0 && data && data.length !== 0) {
        this.imgArrAttachments = data
        this.checkedListData = [{ id: this.$route.query.docId, attachments: data }]
        this.getImageAiDetail()
      }
    },
    // 图片详情
    async getImageAiDetail () {
      let { status, data } = await APIS.postImageAiDetail({ data: { id: this.currentId } })
      if (status === 0 && data) {
        this.currentTab = 'tag'
        this.detailInfo = Object.assign({}, this.detailInfo, {
          checkStatus: data.status || 0,
          checkResult: data.check || [],
          conclusion: data.checkResult,
          tag: data.tag ? data.tag.map(item => {
            return {
              keyword: item.keyword,
              score: item.score
            }
          }) : [],
          character: data.face || {}
        })
      }
    },
    // 图片标签修改
    async getImageAiUpdate(updateParams) {
      let params = {
        id: this.currentId,
        docId: this.$route.query.docId,
        tag: [...updateParams]
      }
      let { status, message } = await APIS.postImageAiUpdate({
        data: params,
        headers: { 'Content-Type': 'application/json' }
      })
      if (status !== 0) {
        this.global_.handleMessageTips(message, 'error')
      }
    },
    // 图片检测
    async getImageAiCheck(params) {
      let { status, message } = await APIS.postImageAiCheck({
        data: params,
        headers: { 'Content-Type': 'application/json' }
      })
      if (status === 0) {
        this.global_.handleMessageTips(
          `检测任务已创建，请稍候在图片详情中查看分析结果`,
          'success'
        )
      } else {
        this.global_.handleMessageTips(message, 'error')
      }
    },
    updateIndex(index) {
      this.imgIndex = index
      this.getImageAiDetail()
    },
    // 重新检测
    checkReback() {
      this.$refs.checkDialog.$refs.videoCheckDialog.cyDialogCommon = true
      this.$nextTick(() => {
        this.$refs.checkDialog.initData()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.jlxk-img-detection-detail {
  display: flex;
  justify-content: space-between;
  @extend .comBackground;
  margin-top: 30px;
  padding: 20px 30px 20px 20px;
  min-height: calc(100vh - 100px);
  .left {
    width: 610px;
  }
  /deep/ .el-tabs {
    width: 520px;
    &__header {
      margin: 0;
    }
    &__nav-wrap {
      &:after {
        height: 1px;
        background-color: #edf0f7;
      }
    }
    .empty {
      margin: 70px auto 20px;
      text-align: center;
      h6 {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
      }
    }
  }
}
</style>
